import React from 'react';
import { AboutMainSection } from './sections/about/Main';
import { WhatMainSection } from './sections/what/Main';
import { WhatStepOneSection } from './sections/what/StepOne';
import { WhoNeedsMainSection } from './sections/who_needs/Main';
import { WhoNeedsStepOneSection } from './sections/who_needs/StepOne';
import { WhoNeedsStepTwoSection } from './sections/who_needs/StepTwo';
import { WhoCreatedMainSection } from './sections/who_created/Main';
import { WhoCreatedStepOneSection } from './sections/who_created/StepOne';
import { WhyMainSection } from './sections/why/Main';
import { WhyStepOneSection } from './sections/why/StepOne';
import { SupportMainSection } from './sections/support/Main';
import { SupportStepOneSection } from './sections/support/StepOne';
import { GatewayMainSection } from './sections/gateway/Main';
import { GatewayStepOneSection } from './sections/gateway/StepOne';
import { GatewayStepTwoSection } from './sections/gateway/StepTwo';

export const SectionSelector = ({ currentSection }) => {
  switch (currentSection) {
    case 'about':
      return <AboutMainSection />;
    case 'what_is':
      return <WhatMainSection />;
    case 'what_is_1':
      return <WhatStepOneSection />;
    case 'who_needs':
      return <WhoNeedsMainSection />;
    case 'who_needs_1':
      return <WhoNeedsStepOneSection />;
    case 'who_needs_2':
      return <WhoNeedsStepTwoSection />;
    case 'who_created':
      return <WhoCreatedMainSection />;
    case 'who_created_1':
      return <WhoCreatedStepOneSection />;
    case 'why':
      return <WhyMainSection />;
    case 'why_1':
      return <WhyStepOneSection />;
    case 'supports':
      return <SupportMainSection />;
    case 'supports_1':
      return <SupportStepOneSection />;
    case 'gateway':
      return <GatewayMainSection />;
    case 'gateway_1':
      return <GatewayStepOneSection />;
    case 'gateway_2':
      return <GatewayStepTwoSection />;

    default:
      return null;
  }
};
